// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    actualCompletionDate: 'Finalización Real. Fecha: ',
    actualCompletionDateFull: 'Fecha de Finalización Real',
    AutoAssign_Issue: 'Asignar automáticamente nuevos problemas a:',
    AutoAssign_Note: 'El miembro elegido se asignará cada vez que se agregue una actividad al proyecto',
    AutoAssign_Request: 'Asignar automáticamente nuevas solicitudes a:',
    AutoAssign_Task: 'Auto asignar nuevas tareas a:',
    AutoAssign_Title: 'Asignación automática',
    BaselineCaptureLabel: 'Línea Base de Captura',
    BaselineOverwrite: 'Sobrescribir la línea de base actual?',
    BaselineOverwriteDescription: 'Ya tiene una línea de base para este proyecto. Si continúa, se perderá la línea de base actual.',
    BaselineRecaptureLabel: 'Sobrescribir la Línea Base',
    BaselineSuccess: 'La línea de base se ha capturado con éxito.',
    Billed: 'Facturado',
    Billing: 'Facturación',
    BillingSettingsTitle: 'Configuración de facturación',
    BillingTypeNotBillable: 'No facturable',
    BillingTypeProjectBillingSettings: 'Configuración de facturación del proyecto',
    btnNotifications: 'Notificaciones',
    BudgetLeft: ' izquierda',
    BudgetTotal: ' total',
    By: 'por ',
    Change: 'cambiar',
    Close: 'Cerrar',
    ConfirmStatusDialogTitle: 'Completo \"{0}\"?',
    DayPluralFormat: '1#{0} día#{0} dias',
    Days: '({0}d)',
    DeleteActivity: 'Eliminar la actividad',
    DeleteProject: 'Eliminar proyecto',
    Dependencies_Count: '1#{0} Dependencia#{0} Dependencias',
    DifferPermissionsMessage: 'indica que los permisos de los miembros actuales del proyecto difieren de los permisos de rol predeterminados',
    DueIn_Ok: 'debido en {0}',
    DueIn_Trouble: '{0} atrasado',
    DueIn_Warning: 'hoy',
    EditRoleAndPermissions: 'Editar rol y permisos',
    endDate: 'Fecha de Finalización Prevista: ',
    endDateFull: 'Fecha de Finalización Prevista',
    endLessThenStartMsg: '\'Fecha de finalización\' no puede ser menor que \'Fecha de inicio\'',
    estimatedHours: '1# hora estimada# horas estimadas',
    ExportToMsProject: 'Exportar a MS Project',
    Fields: '1#{0} campo#{0} campos',
    FillCustomFields: '{0} aún debe completarse',
    Follow: 'Seguir',
    HideCustomFields: 'Ocultar campos personalizados',
    hoursLeft: '1 # hora restante# horas restantes',
    HoursOf: 'h de ',
    HtmlField_ReadAll: '... leer todo',
    ImDoneText: 'He terminado',
    IsMilestone: 'Esto es un hito',
    issue: 'Asunto',
    MarkAsMilestone: 'Marcar como un hito',
    MemberPermission_Add: 'Agregar',
    MemberPermission_Add_For_Someone_Else: 'Añadir para otra persona',
    MemberPermission_Add_Own: 'Añadir propio',
    MemberPermission_CanEditActualExpenses: 'Editar Gastos Reales',
    MemberPermission_CanEditPlannedExpenses: 'Editar Gastos Planificados',
    MemberPermission_CanLogExpenses: 'Registro de Gastos',
    MemberPermission_CanManageProjectMembers: 'Administrar miembros',
    MemberPermission_CanViewMembersAndAssignees: 'Ver',
    MemberPermission_Delete: 'Eliminar',
    MemberPermission_Delete_All: 'Eliminar todo',
    MemberPermission_Delete_Or_Archive: 'Eliminar/Archivo',
    MemberPermission_Edit: 'Editar',
    MemberPermission_Edit_All: 'Editar todo',
    MemberPermission_Edit_Assigned: 'Editar asignado',
    MemberPermission_Manage_Assigned: 'Administrar asignados',
    MemberPermission_View_All: 'Ver todo',
    MemberPermission_View_and_Manage: 'Ver y administrar',
    MemberPermission_View_Assigned: 'Ver asignado',
    MemberPermissions_ExpensesTitle: 'Gastos:',
    MemberPermissions_MembersAndAssigneesTitle: 'Miembros & cesionarios:',
    MemberPermissions_TasksTitle: 'Actividades:',
    MemberPermissions_ThisProjectTitle: 'Proyecto:',
    MemberPermissions_TimeEntriesTitle: 'Entradas de tiempo:',
    Members: '1#{0} Miembro#{0} Miembros',
    no_assignee: 'No cesionario',
    On: ' el ',
    OwnBudget: 'Presupuesto de esta actividad:',
    PercentDone: '1#% hecho#% hecho',
    PermissionsSettingsTitle: 'permisos de {0}',
    project: 'Proyecto',
    Project_NotFound_Message: 'No se pudo encontrar el proyecto solicitado o no tiene permiso para acceder a él. Consulte con su {brandName} administrador para conocer las posibles causas. La clave de objeto es {0}',
    Project_NotFound_Title: 'Proyecto Solicitado No Encontrado',
    Project_WasCompleted_Ok: 'El proyecto se completó <b>{0} antes</b> de la fecha de finalización prevista',
    Project_WasCompleted_Trouble: 'El proyecto se completó <b>{0} despues</b> de la fecha de finalización prevista',
    Project_WasCompleted_Warning: 'El proyecto se completó en la fecha de finalización prevista',
    RatioOfMoneySpent: '1#{0} de {1} gastado#{0} de {1} gastado',
    RepeatActivity: 'Repetir',
    request: 'Solicitud',
    ResumeWorkHelpText: 'Ha completado su tarea. ',
    ResumeWorkText: 'Reanudar trabajo',
    RoleTitle: 'Rol para este proyecto',
    Save: 'Guardar',
    Set_actualCompletionDate: 'Establecer La Fecha De Finalización Real',
    Set_budget: 'Establecer Presupuesto',
    Set_categoryId: 'Categoría',
    Set_customerId: 'Establecer Cliente',
    Set_dates: 'Establecer Fechas o Duración',
    Set_description: 'Añadir descripción',
    Set_endDate: 'Establecer La Fecha De Finalización Planificada',
    Set_estimatedHours: 'Establecer Horas Estimadas',
    Set_hoursLeft: 'Establecer Las Horas Restantes',
    Set_labor_budget: 'Establecer Un Presupuesto de Mano de Obra',
    Set_portfolioId: 'Establecer Portafolio',
    Set_short_hoursLeft: 'Establecer Las Horas Restantes',
    SetAsRootLevel: 'Establecer como actividad de nivel superior',
    SetCompleted: 'Establecer como Completado',
    short_hoursLeft: '1 # hora restante# horas restantes',
    ShowCustomFields: 'Mostrar campos personalizados',
    Spent: '1 # h gastada#h gastada',
    Status: 'Estado: ',
    task: 'Tarea',
    Task_NotFound_Message: 'La actividad solicitada no se pudo encontrar, o no tiene permiso para acceder a ella. Consulte con su {brandName} administrador para conocer las posibles causas. La clave de objeto es {0}',
    Task_NotFound_Title: 'Actividad Solicitada No Encontrada',
    Task_WasCompleted_Ok: 'La actividad se completó <b>{0} antes de</b> su fecha de finalización prevista',
    Task_WasCompleted_Trouble: 'La actividad se completó <b>{0} despues</b> su fecha de finalización prevista',
    Task_WasCompleted_Warning: 'La actividad se completó en la fecha de finalización prevista',
    today: 'Hoy',
    UnFollow: 'Dejar de seguir',
    WindowUnload_UnsavedChanges: ' Hay cambios no guardados. Estás seguro de que te gustaría dejar esta página?',
};
